import React from "react";
import { useForm, Controller } from "react-hook-form";
import { login } from "_services/oauth";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import InputAdornment from "@material-ui/core/InputAdornment";
import Icon from "@material-ui/core/Icon";

// @material-ui/icons
import Email from "@material-ui/icons/Person";
import LockIcon from "@material-ui/icons/Lock";

// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import CustomInput from "components/CustomInput/CustomInput.js";
import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardHeader from "components/Card/CardHeader.js";
import CardFooter from "components/Card/CardFooter.js";
import Snackbar from "components/Snackbar/Snackbar.js";
import AddAlert from "@material-ui/icons/AddAlert";


import TextField from '@material-ui/core/TextField';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Link from '@material-ui/core/Link';
import Grid from '@material-ui/core/Grid';

import styles from "assets/jss/material-dashboard-react/views/loginPageStyle.js";

import provider_icon from "assets/img/provider_id.png";

const useStyles = makeStyles(styles);


const ResetPwd = (props) => {

    

    const { location, ...other } = props;
    const user = useSelector((state) => state.auth.user);
    const history = useHistory();

    const [cardAnimaton, setCardAnimation] = React.useState("cardHidden");
    const { register, handleSubmit } = useForm();

    const [error, setError] = React.useState(false);
    const [errMsg, setErrMsg] = React.useState("");
    const [snackColor, setSnackColor] = React.useState("danger");
    const [Status, setStatus] = React.useState(200);

    const [Username, setUsername] = React.useState("");
    const [ResetToken, setResetToken] = React.useState("");
    const [Password, setPassword] = React.useState("");
    const [ConfirmPassword, setConfirmPassword] = React.useState("");

    const dispatch = useDispatch();

    React.useEffect(() => {

        const params = new URLSearchParams(window.location.search);
        setUsername((params != null && params.get("username") != null) ? params.get("username") : "");
        setResetToken(decodeURIComponent((params != null && params.get("token") != null) ? params.get("token") : ""));

        let id = setTimeout(function () {
            setCardAnimation("");
        }, 700);



        // Specify how to clean up after this effect:
        return function cleanup() {
            window.clearTimeout(id);
        };



    });
    const classes = useStyles();

    const showNotification = (place) => {
        switch (place) {
            case "tr":
                if (!error) {
                    setError(true);
                    setTimeout(function () {
                        setError(false);
                    }, 6000);
                }
                break;
            default:
                break;
        }
    };

  
    const onSubmit = () => {
        const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{8,}$/;

        if (!passwordRegex.test(Password)) {
            setErrMsg("รหัสผ่านต้องมีอย่างน้อย 8 ตัวอักษร และต้องมีตัวพิมพ์ใหญ่ พิมพ์เล็ก และตัวเลข");
            setSnackColor('danger');
            showNotification("tr");
            //alert("รหัสผ่านต้องมีอย่างน้อย 8 ตัวอักษร และต้องมีตัวพิมพ์ใหญ่ พิมพ์เล็ก และตัวเลข")
            return;
        }

        if (Password !== ConfirmPassword) {
            setErrMsg("รหัสผ่านและยืนยันรหัสผ่านไม่ตรงกัน");
            setSnackColor('danger');
            showNotification("tr");

            //alert("รหัสผ่านและยืนยันรหัสผ่านไม่ตรงกัน")
            return;
        }

        // ถ้าผ่านเงื่อนไขทั้งหมด ค่อยส่ง API
        axios.post("/api/v1/identity/reset", {
            Username: Username,
            ResetToken: ResetToken,
            Password: Password
        })
            .then(result => {
                if (result.data.result === 200) {
                    setErrMsg(result.data.msg);
                    setSnackColor('success');
                    showNotification("tr");

                    const timer = setTimeout(() => {
                        window.location.href = '/auth/login-page';
                    }, 3000); // 3000 มิลลิวินาที = 3 วินาที


                } else if (result.data.result === 404) {
                    setErrMsg(result.data.msg);
                    setSnackColor('danger');
                    showNotification("tr");

                    //alert(result.data.msg);
                }
            })
            .catch(error => {
                console.log(error);

                setErrMsg(error);
                setSnackColor('danger');
                showNotification("tr");
            });
    };

    return (
        <div className={classes.container}>
            <GridContainer justify="center">
                <GridItem xs={12} sm={12} md={6}>


                    <form onSubmit={handleSubmit(onSubmit)}>
                        <Card login className={classes[cardAnimaton]}>
                            <CardHeader
                                className={`${classes.cardHeader} ${classes.textCenter}`}
                                color="info"
                            >
                                <h4 className={classes.cardTitle}>Reset รหัสผ่าน E-Service SKIN@Trang</h4>
                                <div className={classes.socialLine}>
                                    {[
                                        { icon: "fab fa-chrome", url: "http://www.trangskin.go.th" },
                                        { icon: "fab fa-facebook-square", url: "https://www.facebook.com/trangskin" },
                                        { icon: "fab fa-youtube-square", url: "https://www.youtube.com/@skintrang" },
                                    ].map((prop, key) => {
                                        return (
                                            <a href={prop.url} target='_blank'>
                                                <Button
                                                    color="transparent"
                                                    justIcon
                                                    key={key}
                                                    className={classes.customButtonClass}
                                                >
                                                    <i className={prop.icon} />
                                                </Button>
                                            </a>
                                        );
                                    })}
                                </div>
                            </CardHeader>

                            <CardBody>
                                <TextField
                                    inputRef={register}
                                    name="email"
                                    variant="outlined"
                                    margin="normal"
                                    required
                                    fullWidth
                                    label="Username"
                                    readonly
                                    value={ Username }
                                   
                                />
                                <TextField
                                    inputRef={register}
                                    name="password"
                                    variant="outlined"
                                    margin="normal"
                                    required
                                    fullWidth
                                    label="Password"
                                    type="password"
                                    onChange={e => setPassword(e.target.value)}
                                />
                                <TextField
                                    inputRef={register}
                                    name="confirmpassword"
                                    variant="outlined"
                                    margin="normal"
                                    required
                                    fullWidth
                                    label="Confirm Password"
                                    type="password"
                                    onChange={e => setConfirmPassword(e.target.value)}
                                />

                            </CardBody>

                            

                            <CardFooter className={classes.justifyContentCenter} >

                                <Grid container>
                                    <Grid xs={12} sm={12} md={12} >
                                        <Button type="submit" color="info" size="lg" block>
                                            เปลี่ยนรหัสผ่าน
                                        </Button>
                                    </Grid>

                                    <Grid xs={12} sm={12} md={12}>
                                        <Snackbar
                                            place="tr"
                                            color={snackColor}
                                            icon={AddAlert}
                                            message={errMsg}
                                            open={error}
                                            closeNotification={() => setError(false)}
                                            close
                                        />
                                    </Grid>
                                </Grid>

                              

                            </CardFooter>
                        </Card>
                    </form>
                </GridItem>
            </GridContainer>
        </div>
    );
}
export default ResetPwd;